import React from "react";
import { useEffect } from "react";
import Hero from "../Heroes/Hero";
import SectionWallet from "../SectionWallet/SectionWallet";
import SectionBank from "../SectionBank/SectionBank";
import CryptoBank from "../CryptoBank/CryptoBank";
import SectionPartners from "../SectionPartners/SectionPartners";
import SectionCard from "../SectionCard/SectionCard";
import SectionCta from "../SectionCta/SectionCta";
import SectionPress from "../SectionPress/SectionPress";
import SectionWealth from "../SectionWealth/SectionWealth";
import SectionAdvantages from "../SectionAdvantages/SectionAdvantages";
import SectionTheExchangeHome from "../SectionTheExchangeHome/SectionTheExchangeHome"
import {
    sliderDataLandingPage, textDataWealthSection,
} from "../SectionWealth/wealthItems";

import { cardItems } from "../SectionCard/sectionCardItems";


const heroObj = {
    titleObj: {
        h1: "Best In Class",
        h2: "At Boosting Income",
        h3: "For All",
        h4: "All-in-one personal finance management app for iOS And Android.",
        // titleWithLink: "Crypto Debit Card.",
    },
    text: "",
    appBtnsVisible: true,
    scrollBtnText: ""
};
//         h4: "Changex is web3's Swiss Knife of personal finance and the best at boosting investors' income!",

const cardContent = {
    head1: "Meet The",
    head2: "Changex",
    head3: "Debit Card",
    paragraph: 'A centrally-issued bank card that works with your decentralized tokens.',
    page: "Home",
};

export default function Home() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Hero heroObj={heroObj} />
            <SectionWallet />
            <SectionTheExchangeHome />
            <SectionWealth textData={textDataWealthSection} cardItemsWealth={sliderDataLandingPage} />
            <SectionCard cardContent={cardContent} />
            <SectionAdvantages
                pageClass={'cardPage'}
                classGrid={"card-grid"}
                title={"The Crypto Card That Changes Everything"}
                advantages={cardItems}
            />
            <SectionBank />
            <CryptoBank />
            {/* <SectionPartners /> */}
            <SectionCta />
            <SectionPress />
        </>
    );
}
